<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import TopNav from "./components/common/TopNav.vue";
export default {
  name: 'App'
}
</script>

<style>
html {
  background: linear-gradient(135deg, #dce8f5 0%, #e8f0fe 20%, #f0e8ff 45%, #fce4ec 70%, #fff3e0 100%);
  margin: 0;
  padding: 0;
  min-height: 100%;
}

body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background: linear-gradient(135deg, #dce8f5 0%, #e8f0fe 20%, #f0e8ff 45%, #fce4ec 70%, #fff3e0 100%);
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: linear-gradient(135deg, #dce8f5 0%, #e8f0fe 20%, #f0e8ff 45%, #fce4ec 70%, #fff3e0 100%);
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue